import * as Yup from 'yup'
const positiveVal = 'Value must be greater than 0'
const canBeZeroVal = 'Value must be 0 or greater than 0'
const basicValidations = {
  productName: Yup.string().required('Product Name is required'),
  customerType: Yup.string().required('Customer Type is required'),
}
const solarbasicValidations = {
  productName: Yup.string().required('Product Name is required'),
  product: Yup.string().required('Product  is required'),
  // customerType: Yup.string().required('Customer Type is required'),
  solarFarmName: Yup.string().required('Solar Farm Name is required'),
  // productCode: Yup.string().required('Product Code is required'),
  billingMethod: Yup.string().required('Billing Method is required'),
  discount: Yup.string().required('Discount is required'),
  dealSourceTier: Yup.string().required('Deal Source Tier is required'),
  availableCustomers: Yup.string().required('Available Customers is required'),
  // creditCheckRequired: Yup.string().required('Credit Check Required is required'),
  // state: Yup.string().required('State is required'),
  // utility: Yup.string().required('Utility is required'),
  // productStatus: Yup.string().required('Product Status is required'),
}
const electricValidations = {
  utility: Yup.string().required('Utility is required'),
  unit: Yup.string().required('Unit is required'),
  rate: Yup.number()
    .required('Rate is required')
    .min(0, 'E_Rate must be greater than or equal to zero'),
  secondRate: Yup.number().positive(positiveVal),
  earlyTerminationFee: Yup.number().min(0, canBeZeroVal),
  serviceFee: Yup.number().min(0, canBeZeroVal),
  deposit: Yup.number().positive(positiveVal),
  contractType: Yup.string().required('E_contract Type is required'),
  ecode: Yup.string().required('E_Product Code is required').nullable(),
  ebillingMethod: Yup.string().required('E_Billing Method is required'),
}
const dynamicelectricValidations = {
  utility: Yup.string().required('Utility is required'),
  unit: Yup.string().required('Unit is required'),
  rateMinimum: Yup.number()
    .required('Minimum E_Rate is required')
    .min(0, 'Minimum E_Rate must be greater than or equal to zero'),
  rateMaximum: Yup.number()
    .required('Maximum E_Rate is required')
    .when('rateMinimum', (rateMinimum, schema) =>
      schema.test({
        test: (value: any) => value > rateMinimum,
        message: 'Maximum E_Rate must be greater than Minimum Rate',
      })
    ),
  termMinimum: Yup.number()
    .required('Minimum E_Term is required')
    .min(0, 'Minimum E_Rate must be greater than or equal to zero'),
  termMaximum: Yup.number()
    .required('Maximum E_Term is required')
    .when('termMinimum', (termMinimum, schema) =>
      schema.test({
        test: (value: any) => value > termMinimum,
        message: 'Maximum E_Term must be greater than Minimum Term',
      })
    ),
  secondRate: Yup.number().positive(positiveVal),
  earlyTerminationFee: Yup.number().min(0, canBeZeroVal),
  serviceFee: Yup.number().min(0, canBeZeroVal),
  deposit: Yup.number().positive(positiveVal),
  contractType: Yup.string().required('E_contract Type is required'),
  ecode: Yup.string().required('E_Product Code is required').nullable(),
  ebillingMethod: Yup.string().required('E_Billing Method is required'),
}

const gasValidations = {
  grate: Yup.number()
    .required('Rate is required')
    .min(0, 'G_Rate must be greater than or equal to zero'),
  gsecondRate: Yup.number().positive(positiveVal),
  gearlyTerminationFee: Yup.number().min(0, canBeZeroVal),
  gserviceFee: Yup.number().min(0, canBeZeroVal),
  gdeposit: Yup.number().positive(positiveVal),
  gutility: Yup.string().required('Utility is required'),
  gunit: Yup.string().required('Unit is required'),
  gcontractType: Yup.string().required('G_contract Type is required'),
  gcode: Yup.string().required('G_Product Code is required').nullable(),
  gbillingMethod: Yup.string().required('G_Billing Method is required'),
}
const dynamicgasValidations = {
  grateMinimum: Yup.number()
    .required('Minimum G_Rate is required')
    .min(0, 'Minimum G_Rate must be greater than or equal to zero'),
  grateMaximum: Yup.number()
    .required('Maximum G_Rate is required')
    .when('grateMinimum', (grateMinimum, schema) =>
      schema.test({
        test: (value: any) => value > grateMinimum,
        message: 'Maximum G_Rate must be greater than Minimum Rate',
      })
    ),
  gtermMinimum: Yup.number()
    .required('Minimum G_Term is required')
    .min(0, 'Minimum G_Term must be greater than or equal to zero'),
  gtermMaximum: Yup.number()
    .required('Maximum G_Term is required')
    .when('gtermMinimum', (gtermMinimum, schema) =>
      schema.test({
        test: (value: any) => value > gtermMinimum,
        message: 'Maximum G_Term must be greater than Minimum Term',
      })
    ),
  gunit: Yup.string().required('Unit is required'),
  gsecondRate: Yup.number().positive(positiveVal),
  gearlyTerminationFee: Yup.number().min(0, canBeZeroVal),
  gserviceFee: Yup.number().min(0, canBeZeroVal),
  gdeposit: Yup.number().positive(positiveVal),
  gutility: Yup.string().required('Utility is required'),
  gcontractType: Yup.string().required('G_contract Type is required'),
  gcode: Yup.string().required('G_Product Code is required').nullable(),
  gbillingMethod: Yup.string().required('G_Billing Method is required'),
}
const billingMethodOptions = [
  {
    id: 'MarketerBillReady',
    value: 'MarketerBillReady',
    type: 'billingMethod',
  },
  {
    id: 'UtilityBillReady',
    value: 'UtilityBillReady',
    type: 'billingMethod',
  },
  {
    id: 'UtilityRateReady',
    value: 'UtilityRateReady',
    type: 'billingMethod',
  },
  {
    id: 'Dual',
    value: 'Dual',
    type: 'billingMethod',
  },
]
export {
  basicValidations,
  solarbasicValidations,
  electricValidations,
  dynamicelectricValidations,
  gasValidations,
  dynamicgasValidations,
  billingMethodOptions,
}
